import React, { useEffect } from 'react'
import Webphone from 'common/Webphone'
import { useDispatch, useSelector } from 'react-redux'
import { WebphoneRouter } from 'common/WebphoneRouter'
import { getProfile } from 'store/actions/profile'
import './lang/i18n'

import ParentNotifier from 'common/ParentNotifier'
import Broadcast from 'common/Broadcast'

import { isEmpty, isEqual } from 'lodash'
import { AppContainer } from 'components/layout/AppContainer'
import { AlertContainer, Preloader, AudioElement } from 'components/shared'

import {
    useCodecCapabilities,
    usePrevious,
    useCallToUrlParameter,
    useNetworkSatus,
    useBeforeUnloadPrompt,
    useBrowserMedia,
    useIntegration,
    useTokenLogin,
    useUniqueTab,
    useThemeWhitelabelColors
} from 'hooks'

import { AppContext } from 'common/Globals'

Broadcast.init()
ParentNotifier.init()

const WhitelabelColors = useThemeWhitelabelColors()

export function App() {
    const dispatch = useDispatch()
    const accessToken = useSelector((state) => state.auth.access_token)
    const isUserAuthed = !!accessToken
    const { data: profileData } = useSelector((state) => state.profile)
    const prevProfileData = usePrevious(profileData)

    // Get user profile info
    useEffect(() => {
        if (isUserAuthed) {
            dispatch(getProfile())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accessToken])

    useEffect(() => {
        !isEmpty(profileData) && !isEqual(profileData, prevProfileData) && Webphone.init(profileData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profileData])

    useUniqueTab({ isUserAuthed })
    useTokenLogin()
    useIntegration()
    useBrowserMedia({ isUserAuthed })
    useBeforeUnloadPrompt()
    useNetworkSatus()
    useCallToUrlParameter()
    useCodecCapabilities()

    return (
        <AppContext.Provider value={{ isUserAuthed }}>
            <AppContainer>
                <WebphoneRouter />
                <AudioElement />
                <AlertContainer />
                <Preloader />
            </AppContainer>
            <WhitelabelColors />
        </AppContext.Provider>
    )
}
